<ion-header collapse="fade" class="ion-no-border">


    <ion-toolbar #toolbar
                 mode="md"
                 class="header-background header"

                 *ngIf="dataSRV.isAuthenticated.value == true "

    >
        <ion-buttons slot="start">

            <ion-badge
                    *ngIf="this.dataSRV.feedUnreadCounter > 0"
                    color="dark"
                    style="
        --background: transparent;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 100%;
        opacity: 0.95;
        z-index: 10;
      ">
                {{ this.dataSRV.feedUnreadCounter }}
            </ion-badge>
            <ion-icon *ngIf="dataSRV.displayUpdatePrompt.value" color="danger" size="small" name="alert-circle-outline"></ion-icon>

            <ion-menu-button menu="mobileMenu">
                <ion-icon name="menu"></ion-icon>
            </ion-menu-button>
        </ion-buttons>

        <ion-buttons slot="end">
            <ion-badge
                    *ngIf="this.dataSRV.cartCounter >= 0"
                    color="dark"
                    style="
      transform: scale(0.8);
        --background: transparent;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 100%;
        opacity: 0.95;
        z-index: 10;
      ">
                {{ this.dataSRV.cartCounter }}
            </ion-badge>

            <ion-spinner *ngIf="this.dataSRV.cartCounter == undefined" style="transform: scale(0.3); position: absolute; top: 0; right: 0" name="crescent">
            </ion-spinner>

            <ion-button [disabled]="paymentSRV.processingPayment.value==true && paymentSRV.showReceipt.value==false" (click)="dataSRV.paymentsModal()">
                <ion-icon name="cart" style="font-size: x-large;" color="dark"></ion-icon>
            </ion-button>
        </ion-buttons>

        <div *ngIf="dataSRV.settings['global']" style="text-align: center;max-height: 60px;">
            <img style="max-height: 60px;" *ngIf="(dataSRV.settings['global']['default_logo_url'] | json)!='{}'" [src]="dataSRV.settings['global']['default_logo_url']">
        </div>

        <ion-progress-bar
                *ngIf="loaderSRV.progressBarLoading"
                color="dark"
                type="indeterminate">
        </ion-progress-bar>
    </ion-toolbar>

    <ion-toolbar #toolbar *ngIf="dataSRV.isAuthenticated.value == true && paymentSRV.processingPayment.value==true && paymentSRV.showReceipt.value==false " style="text-align: center" mode="ios">

        <ion-chip style="font-weight: bold">{{ ('keys.data.payments.processing_payment' |
            translate : {Default: 'Processing payment...'}) || 'Processing payment...' }}
        </ion-chip>

        <ion-progress-bar
                color="dark"
                type="indeterminate">

        </ion-progress-bar>
    </ion-toolbar>

    <ion-toolbar #toolbar *ngIf="dataSRV.isAuthenticated.value == true && paymentSRV.showReceipt.value==true">
        <ion-chip slot="start" color="success" style="font-weight: bold">{{ ('keys.data.payments.receipt_ready' |
            translate : {Default: 'Your receipt is ready'}) || 'Your receipt is ready' }}
        </ion-chip>

        <ion-button color="primary" expand="block" (click)="paymentSRV.openReceipt()">
            {{ paymentSRV.comment }} {{ ('keys.data.payments.open_receipt' | translate : {Default: 'Open receipt'}) || 'Open receipt' }}
        </ion-button>
    </ion-toolbar>

    <ion-toolbar class="header-background" *ngIf=" dataSRV.isAuthenticated.value == true && dataSRV.isTemp==true">
        <ion-item>
            <ion-label>{{ ('keys.data.profile.logged_in_as_employee' |
                translate : {Default: 'Logged in as company employee'}) || 'Logged in as company employee' }}</ion-label>
            <ion-icon name="people" class="ion-text-right"></ion-icon>
        </ion-item>
    </ion-toolbar>
    <!-- <ion-toolbar  class="header-background" *ngIf="!platformSRV.isNative.value">
      <ion-item lines="none" style="text-align: center;" button>
        <ion-label>Click here to go back back to the older version</ion-label>

      </ion-item>
      </ion-toolbar> -->
</ion-header>